export const ROUTE_SEGMENTS = {
  AUTH: 'auth',
  LOGIN: 'login',
  UNAUTHORIZED: 'unauthorized',
  DASHBOARD: 'dashboard',
  PATIENTS: 'patients',
  ORGANIZATION: 'organization',
  DOCTORS: 'doctors',
  APPOINTMENTS: 'appointments',
  BILLING: 'billing',
  PAYROLL: 'payroll',
  PROFILE: 'profile',
  SETTINGS: 'settings',
  WILDCARD: '**',
} as const;

export const APP_ROUTES = {
  dashboard: `/${ROUTE_SEGMENTS.DASHBOARD}`,
  patients: `/${ROUTE_SEGMENTS.PATIENTS}`,
  organization: `/${ROUTE_SEGMENTS.ORGANIZATION}`,
  doctors: {
    root: `/${ROUTE_SEGMENTS.DOCTORS}`,
    new: `/${ROUTE_SEGMENTS.DOCTORS}/new`,
    detail: (id: string) => `/${ROUTE_SEGMENTS.DOCTORS}/${id}`,
    edit: (id: string) => `/${ROUTE_SEGMENTS.DOCTORS}/${id}/edit`,
    availability: (id: string) => `/${ROUTE_SEGMENTS.DOCTORS}/${id}/availability`,
    mywork: (id: string) => `/${ROUTE_SEGMENTS.DOCTORS}/${id}/mywork`,
  },
  appointments: {
    root: `/${ROUTE_SEGMENTS.APPOINTMENTS}`,
    detail: (id: string) => `/${ROUTE_SEGMENTS.APPOINTMENTS}/${id}`,
    print: (id: string) => `/${ROUTE_SEGMENTS.APPOINTMENTS}/${id}/print`,
  },
  billing: {
    root: `/${ROUTE_SEGMENTS.BILLING}`,
    new: `/${ROUTE_SEGMENTS.BILLING}/new`,
    detail: (id: string) => `/${ROUTE_SEGMENTS.BILLING}/${id}`,
    edit: (id: string) => `/${ROUTE_SEGMENTS.BILLING}/${id}/edit`,
    print: (id: string) => `/${ROUTE_SEGMENTS.BILLING}/${id}/print`,
  },
  payroll: {
    root: `/${ROUTE_SEGMENTS.PAYROLL}`,
    employees: `/${ROUTE_SEGMENTS.PAYROLL}/employees`,
    newEmployee: `/${ROUTE_SEGMENTS.PAYROLL}/employees/new`,
    employeeDetail: (id: string) => `/${ROUTE_SEGMENTS.PAYROLL}/employees/${id}`,
    employeeEdit: (id: string) => `/${ROUTE_SEGMENTS.PAYROLL}/employees/${id}/edit`,
    offerLetters: `/${ROUTE_SEGMENTS.PAYROLL}/offer-letters`,
    internshipCertificates: `/${ROUTE_SEGMENTS.PAYROLL}/internship-certificates`,
    salaryStructures: `/${ROUTE_SEGMENTS.PAYROLL}/salary-structures`,
    employeeSalaryStructures: `/${ROUTE_SEGMENTS.PAYROLL}/employee-salary-structures`,
    newEmployeeSalaryStructure: (id: string) => `/${ROUTE_SEGMENTS.PAYROLL}/employee-salary-structures/new/${id}`,
    separation: `/${ROUTE_SEGMENTS.PAYROLL}/separation`,
    settings: `/${ROUTE_SEGMENTS.PAYROLL}/settings`,
  },
  auth: {
    root: `/${ROUTE_SEGMENTS.AUTH}`,
    login: `/${ROUTE_SEGMENTS.AUTH}/${ROUTE_SEGMENTS.LOGIN}`,
    unauthorized: `/${ROUTE_SEGMENTS.AUTH}/${ROUTE_SEGMENTS.UNAUTHORIZED}`,
  },
  profile: `/${ROUTE_SEGMENTS.PROFILE}`,
  settings: `/${ROUTE_SEGMENTS.SETTINGS}`,
} as const;
